/**
 * This function was taken from proserve.util htmlEncode
 * in old WebTMS WebTMS.js file to preserve functionality
 * @param {string} value string value to be encoded
 * @returns encoded version of string
 */
export function htmlEncode(value) {
    // ? &copy; = (C) &reg = (R) &trade = (TM)
    return !value ? value : String(value)
        .replace(/&/g, '&amp;')
        .replace(/>/g, '&gt;')
        .replace(/</g, '&lt;')
        .replace(/"/g, '&quot;');
}